export const MenuIdHelp = 'HELP' as const;
